/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MyDbAdditionalDetails
 */
export interface MyDbAdditionalDetails {
    /**
     * 
     * @type {string}
     * @memberof MyDbAdditionalDetails
     */
    tenant: string;
}

/**
 * Check if a given object implements the MyDbAdditionalDetails interface.
 */
export function instanceOfMyDbAdditionalDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tenant" in value;

    return isInstance;
}

export function MyDbAdditionalDetailsFromJSON(json: any): MyDbAdditionalDetails {
    return MyDbAdditionalDetailsFromJSONTyped(json, false);
}

export function MyDbAdditionalDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyDbAdditionalDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenant': json['tenant'],
    };
}

export function MyDbAdditionalDetailsToJSON(value?: MyDbAdditionalDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenant': value.tenant,
    };
}

